import { render, staticRenderFns } from "./_base-user-group-picker.vue?vue&type=template&id=77c9472c&scoped=true&"
import script from "./_base-user-group-picker.vue?vue&type=script&lang=js&"
export * from "./_base-user-group-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-user-group-picker.vue?vue&type=style&index=0&id=77c9472c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9472c",
  null
  
)

export default component.exports